import { Box, Divider } from "@mui/material";
import RenderCategoryContent from "./renderCategoryContent";
import RenderCategoryHead from "./renderCategoryHead";
import RenderCategorySummery from "./renderCategorySummery";
import React from "react";

const RenderCategoryAnalytics = (): React.JSX.Element => (
  <Box
    sx={{
      backgroundColor: (theme) => theme.palette.grey[100],
      borderRadius: 2,
      px: 2,
      py: 2,
      mb: 2,
    }}
  >
    <RenderCategoryHead />
    <Divider sx={{ my: 1 }} />
    <RenderCategoryContent />
    <Divider sx={{ my: 1 }} />
    <RenderCategorySummery />
  </Box>
);

export default RenderCategoryAnalytics;
